import getApiClient from 'src/utils/getApiClient'
import type { LpuSpecialitiesResponse } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuDoctorsSchedule/api/apiLpuSpecialities.types'

const apiClient = getApiClient()

const apiLpuSpecialities = {
  post(lpuIds: number[]) {
    return apiClient.post<LpuSpecialitiesResponse>('/ajax/lpus/specialities/', {
      lpus: lpuIds,
    })
  },
}

export default apiLpuSpecialities
